export enum AttendanceReasons {
  OUT_FOR_OFFICIAL_WORK_MEETING = 1,
  FORGOT_TO_PUNCH,
  DELAYED_BY_FOR_TRAFFIC,
  COMPANY_VEHICLE_LATE,
  PERSONAL_EMERGENCY,
  DEVICE_NOT_ACCEPTING,
  OTHER_REASONS,
  NO_PUNCHING_MACHINE_AT_SITE,
}
